import gql from 'graphql-tag';

export const FETCH_APPOINTMENT_SERVICE_PROVIDERS = gql`
  query($serviceId: Int!) {
    getProvidersWithServiceAvailability(
      serviceId: $serviceId
    ) {
      providers {
        userId
        fullName
        isAvailable
      }
      isProviderGroupAvailable
      providerGroupSpecialties {
        specialty {
          name
          id
        }
        isAvailable
      }
    }
  }
`;
